import { getTimezonesForCountry, CountryCode } from "countries-and-timezones";
import { Device } from "../../../../lib/Device";
import dayjs from 'dayjs';

export const FIELD_NAME_TO_TRANSLATION_LABEL: any = {
  power_balance: "power_balance",
  power_balance_no_soliseco: "power_balance_no_soliseco",
  soliseco_power: "soliseco_power",
  p_1_soliseco: "p_1_soliseco",
  p_2_soliseco: "p_2_soliseco",
  p_3_soliseco: "p_3_soliseco",
  u_1: "u_1",
  u_2: "u_2",
  u_3: "u_3",
  water_temperature: "water_temperature",
  dropout_v_max: "dropout_v_max",
  dropout_v_max_l1: "dropout_v_max_l1",
  dropout_v_max_l2: "dropout_v_max_l2",
  dropout_v_max_l3: "dropout_v_max_l3",
  min_planning_temp: "min_planning_temp",
  schedule_standby_line: "schedule_standby",
  circulator_line: "last_info_circulator_state",
  circulator_state: "last_info_circulator_state"
};

export interface LineChartProps {
  lineData: any[];
  currentDevice?: Device;
  ticks: any[];
  lineChartXTickFormatter: any;
  isTelemetryFieldVisible?: (field: string) => boolean;
}

export type ValveSegment = {
  dataKey: string;
  color: string;
  position: string;
  startIndex: number;
  endIndex: number;
};

export const timestampToReadable = (val: number, country: CountryCode) => {
  const homeTimezone = getTimezonesForCountry(country)
  const date = dayjs.unix(val).tz(homeTimezone[0].name)
  // DD-MM = day of month (date()), not weekday (day())
  return date.format("DD-MM HH[h]mm");
}

export const upRounding = (n: number, step: number) => {
  if (n % step === 0) {
    return n
  }
  return n + (step - (n % step))
}
  
export const downRounding = (n: number, step: number) => {
  if (n % step === 0) {
    return n
  }
  return n - (n % step)
}
